<p-confirmDialog header="Confirmation" key="confirmDelete" icon="pi pi-exclamation-triangle"
                 [style]="{width: '350px'}" acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text" />
<div class="card">
    <div class="flex justify-center items-center">
        <div class="grid place-items-center pt-0 mb-2">
            <div class="pb-0">
                <h5>{{!profileGroup || profileGroup.profileSelections.length === 0 ? 'Create' : 'Edit'}} Your Reading Profile</h5>
            </div>
            <div class="pr-0 pt-0 relative top-0 left-0">
                <img src="../../../../assets/badges/beta_reader.png" class="right-0 top-0"/>
            </div>
        </div>
    </div>
    <div>
        <p-tabs [value]="currentSelectedSchemaCode" scrollable>
            <p-tablist>
                <!--following code uses a literal string array as a temporary workaround, actual array should be ProjectSchemas.CODES, but that currently returns an empty array for some reason-->
                @for (code of testArray; track code) {
                    <p-tab [value]="code" (valueChange)="currentSelectedSchemaCode = code">{{ ProjectSchemas.SCHEMADISPLAY_BY_CODE[code].displayName }}</p-tab>
                }
            </p-tablist>
            <p-tabpanels>
                @for (code of testArray; track code) {
                    <p-tabpanel [value]="code">
                        <div class="card grid pt-0 mt-0">
                            <project-descriptor-panel [schemaDisplay]="ProjectSchemas.SCHEMADISPLAY_BY_CODE[code]" [use]="ProjectDescriptorUse.BETA_READER_PROFILE" [profileGroup]="betaReader.getProfileGroupForCode(code)" />
                            <p-button class="col-span-4 col-offset-4 pt-3" [label]="betaReader.getProfileGroupForCode(code).profileSelections.length === 0 ? 'Create Profile and Search' : 'Save Profile and Search'" icon="pi pi-search" (onClick)="save()"  />
                            <!--p-button class="col-span-4 col-offset-4 pt-3" [label]="betaReader.getProfileGroupForCode(code).profileSelections.length === 0 ? 'Create Profile and Search' : 'Save Profile and Search'" icon="pi pi-search" (onClick)="save()"  /-->

                        </div>
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    </div>
</div>
